"use client";
import { useContext, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { StoreContext } from "~/app/store-provider";
import { StoreI } from "~/interfaces";
export default function Overlay() {
  const [store, setStore] = useContext(StoreContext);

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (
        store.app.menu.isMainMenuActive ||
        store.app.menu.isFilterActive ||
        store.app.menu.isLikeActive
      ) {
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.overflowY = "visible";
      }
    }
  }, [
    store.app.menu.isMainMenuActive,
    store.app.menu.isFilterActive,
    store.app.menu.isLikeActive,
  ]);
  return (
    <div
      aria-label={`close menu`}
      onClick={() => {
        setStore((prevStore: StoreI) => ({
          ...prevStore,
          app: {
            ...prevStore.app,
            calendar: {
              ...prevStore.app.calendar,
              isActive: false,
            },
            menu: {
              ...prevStore.app.menu,
              isMainMenuActive: false,
              isFilterActive: false,
              isLikeActive: false,
            },
          },
        }));
      }}
      className={`fun-overlay ${store.app.menu.isMainMenuActive || store.app.menu.isLikeActive || (isMobile && store.app.calendar.isActive) ? "animate-fade-in" : "animate-fade-out-hide"} ${isMobile && store.app.calendar.isActive ? "z-[40]" : "z-[90] delay-[1s] duration-[1s]"} fixed left-0 top-0 min-h-full min-w-full cursor-pointer overflow-hidden bg-darkbrown/90`}
    ></div>
  );
}
